export class userData {
    constructor(private name ,private email,private token)
    {

    }
}